import { CarbonOffsetDrawer } from './Drawers/CarbonOffseDrawer.jsx';
import { SuggestionsDrawer } from './Drawers/SuggestionsDrawer.jsx';
import StyledDrawerPanel from './StyledDrawerPanel.jsx';

const DrawersPanel = () => {
  return (
    <StyledDrawerPanel>
      <SuggestionsDrawer />
      <CarbonOffsetDrawer />
    </StyledDrawerPanel>
  );
};

export default DrawersPanel;
